import { z } from 'zod';

// Original: https://github.com/lessonup/lessonup/blob/a3ac598bc65668a5d456f348e2e8ac9ac3eec5b1/libs/lessonup-core/src/domain/assignment/Assignment.ts

export const DbAssignmentSettingsSchema = z.object({
  _id: z.string(),
  createdAt: z.number(),
  currentView: z.object({
    foregroundPinId: z.string(),
    params: z.any().optional(),
    pinId: z.string(),
  }),
  modifiedAt: z.number(),
  ownerId: z.string(),
  pincode: z.string().nullable(), // TODO: Extract union for open and closed assignments?
  nextAssignmentId: z.string().nullish(),
  nextAssignmentVersion: z.enum(['v2']).nullish(),
  playerSettings: z.object({
    allowConnectedDevices: z.boolean(),
    allowNewPlayers: z.boolean(),
    autoShowRank: z.boolean(),
    ignoreExclusions: z.boolean(),
    isPrepScreenEnabled: z.boolean(),
    isScreenShared: z.boolean(),
    isSoundEnabled: z.boolean(),
  }),
  status: z.enum(['open', 'closed']),
  type: z.enum(['realtime']),
  visibility: z.enum(['all']),
});

export type DbAssignmentSettings = z.infer<typeof DbAssignmentSettingsSchema>;
